<template>
  <div class="pa-5 text-xs-center text-grey title">
    {{ $t('NoItems') }}
  </div>
</template>
